import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import ROUTES from './config/RouteNames';
import store from './redux/store/Store';
import './App.scss';
import PrivateRoute from './routes/PrivateRoute';
import LoginContainer from './containers/LoginContainer';
import { AbilityContext } from './config/Can';
import ability from './config/ability';
import NotFoundContainer from 'containers/NotFoundContainer';

function App() {
	return (
		<Provider store={store}>
			<AbilityContext.Provider value={ability}>
				<div className='App'>
					<Router>
						<Switch>
							<Route exact path={ROUTES.LOGIN} component={LoginContainer} />
							<PrivateRoute path={ROUTES.DASHBOARD_ROOT} />
							<Redirect from={ROUTES.ROOT} to={ROUTES.DASHBOARD_ROOT} exact />
							<Route path='*' component={NotFoundContainer} />
						</Switch>
					</Router>
				</div>
			</AbilityContext.Provider>
		</Provider>
	);
}

export default App;
